import getLocationFromIp from './ipapi';

export default class {
  constructor() {
    this.aroundLatLngInput = document.querySelector('[name="aroundLatLng"]');
    this.areaInput = document.querySelector('[data-widget="area"]');
  }

  init() {
    this.setupEvents();
    getLocationFromIp();
  }

  setupEvents() {
    document.addEventListener('ipapi:success', ({ detail }) => {
      this.aroundLatLngInput.value = detail.aroundLatLng;
      this.areaInput.value = detail.area;
    });

    return this;
  }
}

export var __useDefault = true;
